import request from '@/utils/request'

let ScenicApi = {

  /*景点列表*/
  list(data) {
    return request._post('/shop/plus.scenic.Index/index', data);
},
/*添加景点*/
add(data) {
    return request._post('/shop/plus.scenic.Index/add', data);
},
/*修改景点*/
edit(data) {
    return request._post('/shop/plus.scenic.Index/edit', data);
},
/*删除景点*/
del(data) {
    return request._post('/shop/plus.scenic.Index/del', data);
},
/*景点详情*/
detail(data) {
  return request._post('/shop/plus.scenic.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.scenic.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.scenic.Setting/getSetting', data, errorback);
    },
}
export default ScenicApi;



// WEBPACK FOOTER //
// ./src/api/scenic.js